import { string } from "prop-types";

const AmsterdamNieuwWest = ({ className, lakeClassName }) => (
  <>
    <path
      d="M224.62 220.055V227.05H189.965L189.658 267.013L171 285.595V369.421L353.024 515.599L358.828 508.992L341.414 491.649L361.316 475.132L371.267 476.784L403.609 477.609V490.708H415.218L436.779 480.913L446.731 470.177V465.519H438.438L430.145 457.789V425.58H443.413V380.157H454.194V354.555H458.34V330.82L452.535 316.565H432.633L433.462 301.7L411.901 294.267L425.999 255.451L425.518 237.282H402.332V227.372H365.811V220.055H224.62Z"
      fill="url(#paint5_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M382.901 302.527L359.242 321.109V331.433L336.852 354.97V375.303L359.872 367.829V355.771L383.29 324.413L399.046 321.935V311.001L382.901 302.527Z"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={lakeClassName}
    />
  </>
);

AmsterdamNieuwWest.propTypes = {
  className: string,
  lakeClassName: string,
};

export default AmsterdamNieuwWest;
